import { render, staticRenderFns } from "./EditHospital.vue?vue&type=template&id=4540256f&scoped=true"
import script from "./EditHospital.vue?vue&type=script&lang=js"
export * from "./EditHospital.vue?vue&type=script&lang=js"
import style0 from "./EditHospital.vue?vue&type=style&index=0&id=4540256f&prod&scoped=true&lang=css"
import style1 from "./EditHospital.vue?vue&type=style&index=1&id=4540256f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540256f",
  null
  
)

export default component.exports